const state = () => ({
  sender_with_modifyable_signature_list: null,
});

const getters = {
  sender_with_modifyable_signature_list: (state) => state.sender_with_modifyable_signature_list,
};

const actions = {
  getSendersWithModifyableSignature({ commit }, input) {
    const {
      sender_list,
      signature_list,
    } = input;

    const user_with_signature_id_list = signature_list.map((signature) => signature.user_id);

    const sender_with_modifyable_signature_list = sender_list
      .filter((sender) => sender.signature_can_be_modified_by_connected_user)
      .map((sender) => ({
        ...sender.user,
        has_signature: user_with_signature_id_list.includes(sender.user.id),
      }));

    commit('set_sender_with_modifyable_signature_list', sender_with_modifyable_signature_list);

    return sender_with_modifyable_signature_list;
  },
};

const mutations = {
  set_sender_with_modifyable_signature_list(state, sender_with_modifyable_signature_list) {
    state.sender_with_modifyable_signature_list = sender_with_modifyable_signature_list;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
